export const STRUCTURED_CONTENT_WREX_EDITOR_CLASSNAME = 'wrex-editor';
